export default function fixMapIframe() {
    let mapContainer = document.querySelector('.map-section');

    if (!mapContainer) {
        return;
    }

    setTimeout(function () {
        let map = mapContainer.querySelector('iframe');

        map.setAttribute('title', mapContainer.dataset.title);
    }, 500);
}